module.exports = __webpack_public_path__ + "static/media/icon-online_pay.769838b6.svg";